import {UserRoleType} from "@share/web-conferences/enums/UserRoleType";
import {AgoraRoleTypes} from "@share/web-conferences/enums/AgoraRoleTypes";

const isPresenter = (userRole: UserRoleType) => {
    return userRole == UserRoleType.Presenter;
};

const getClientRole = (userRole: UserRoleType) => {
  return userRole == UserRoleType.Audience
      ? AgoraRoleTypes.Audience
      : AgoraRoleTypes.Host;
};

export {
    isPresenter, getClientRole
}